import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ProductCard } from '../components/ProductCard'
import { storefrontApi } from '../lib/api'
import type { CatalogPayload } from '../types/commerce'

export function Catalog() {
  const [params, setParams] = useSearchParams()
  const [data, setData] = useState<CatalogPayload | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const category = params.get('category')
  const collection = params.get('collection')
  const gender = params.get('gender')
  const search = params.get('search')
  const sort = (params.get('sort') ?? 'newest') as 'newest' | 'price_asc' | 'price_desc' | 'featured'

  useEffect(() => {
    setLoading(true); setError('')
    storefrontApi.catalog({ category, collection, gender, search, sort })
      .then(setData).catch(err => setError(err.message)).finally(() => setLoading(false))
  }, [category, collection, gender, search, sort])

  const setParam = (key: string, value: string) => {
    const next = new URLSearchParams(params)
    if (value) next.set(key, value); else next.delete(key)
    setParams(next)
  }

  return (
    <div className="catalog-page section-shell">
      <div className="catalog-heading">
        <div><span>GK MAISON</span><h1>{search ? `BUSCA: ${search}` : collection ? 'COLEÇÃO' : category ? category.toUpperCase() : gender ? gender.toUpperCase() : 'TODOS OS PRODUTOS'}</h1></div>
        <span>{data?.count ?? 0} itens</span>
      </div>
      <div className="catalog-toolbar">
        <div className="filter-row">
          <select value={gender ?? ''} onChange={e => setParam('gender', e.target.value)} aria-label="Filtrar por gênero">
            <option value="">GÊNERO</option><option value="feminino">FEMININO</option><option value="masculino">MASCULINO</option><option value="unissex">UNISSEX</option>
          </select>
        </div>
        <select value={sort} onChange={e => setParam('sort', e.target.value)} aria-label="Ordenar produtos">
          <option value="newest">NOVIDADES</option><option value="featured">DESTAQUES</option><option value="price_asc">MENOR PREÇO</option><option value="price_desc">MAIOR PREÇO</option>
        </select>
      </div>
      {loading ? <div className="page-message">Carregando produtos...</div> : error ? <div className="page-message">{error}</div> : data?.items.length ? (
        <div className="product-grid">{data.items.map(product => <ProductCard product={product} key={product.id} />)}</div>
      ) : <div className="empty-state empty-state--page"><h2>NENHUM PRODUTO ENCONTRADO</h2><p>Tente ajustar os filtros.</p></div>}
    </div>
  )
}
